import { getServiceStatus } from '../src/actions/service'
import store from './store';

export function registerServicePolling() {
  // First call getStatus outside of the interval so it will not wait 30 seconds.
  store.dispatch(getServiceStatus())

  // Call getStatus every 30 seconds to check wheter the banner should be shown or not.
  setInterval(() => {
    store.dispatch(getServiceStatus())
  }, 30000);
}
